import {
  AfterContentInit,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
}                                                                                      from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, of, Subscription}                  from 'rxjs';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                                      from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                                      from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  FieldStore
}                                                                                      from '../../../stores/farm/field.store';
import {debounceTime, distinctUntilChanged, filter, map}                               from 'rxjs/operators';
import {ApGridPagerType, ApStatsType, IGridPagerData, MapViewCurrentMenu, MapViewMode} from '../../../ap-interface';
import {
  LoginStore
}                                                                                      from '../../../stores/login/login.store';
import {
  CampaignYearStore
}                                                                                      from '../../../stores/login/campaignyear.store';
import {
  ApDynGridStatusColumnConfig
}                                                                                      from '../../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                                      from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  NdiStore
}                                                                                      from '../../../stores/ndi/ndi.store';
import {
  ApDynComponentComponent
}                                                                                      from '../../../ap-dyncomponent/ap-dyncomponent.component';
import {
  LanguageStore
}                                                                                      from '../../../stores/translation/language.store';
import {
  ApDynGridPagerConfig,
  IDynGridWizardChoiceData
}                                                                                      from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {
  ApDateService
}                                                                                      from '../../../ap-core/services/ap-date-service';
import {
  IGridStatus
}                                                                                      from '../../../ap-interface/interfaces/ap-grid-status.interface';
import {
  StatisticStore
}                                                                                      from '../../../stores/statistic/statistic.store';
import {
  MapViewStore
}                                                                                      from '../../../stores/layout/mapview.store';
import {
  ApTranslationService
}                                                                                      from '../../../ap-utils/service/ap-translation.service';
import {
  orderBy
}                                                                                      from '@progress/kendo-data-query';
import {
  ApGetCropService
}                                                                                      from '../../../stores/services/ap-get-crop.service';
import {ObjectFactory}                                                                 from 'ts-tooling';
import {
  NotifyStore
}                                                                                      from '../../../stores/dialog/notify.store';
import {
  ApDynformsConfigFieldset
}                                                                                      from '../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigNumerictextbox
}                                                                                      from '../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsConfigPlaceholder
}                                                                                      from '../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {
  FieldMassEditAction
}                                                                                      from '../field-overview.component';
import {
  ApDynformsValidator
}                                                                                      from '../../../ap-dynforms/ap-dynforms-validator';
import {Validators}                                                                    from '@angular/forms';
import {GetRoundNumericPipe}                                                           from '../../../ap-utils';
import {
  SettingsStore
}                                                                                      from '../../../stores/base-data/settings.store';
import {
  NUptakeFactorsStore
}                                                                                      from '../../../stores/common/nuptake-factors.store';
import {
  ApDynGridGroupColumnConfig
}                                                                                      from '../../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  INdiGridData,
  NdiActiveView,
  NdiGridItemState,
  NdiNUptakeState,
  SatelliteMassEditAction
} from '../../types/ndi.types';
import {
  MapStore
}                                                                                      from '../../../stores/map/map.store';
import {
  AgriportConstantsService
}                                                                                      from '../../../services/common/agriport-constants.service';
import {
  NdiService
}                                                                                      from '../../services/ndi.service';
import {
  StatisticService
}                                                                                      from '../../../services/data/statistic.service';
import {
  MapFactoryStyler
}                                                                                      from '../../../map-factory/style';
import {
  CampaignYearService
}                                                                                      from '../../../services/data/campaign-year.service';
import {
  IFieldsNdiStatsData
}                                                                                      from '../../../statistics/components/charts/fields-ndi-stats/fields-ndi-stats.types';
import {
  nameOf
}                                                                                      from '../../../ap-core/utils/ap-name-of';
import {SatelliteNValues}                                                              from '../../../types/ndi.types';
import {
  GetRoundNumericPipeConfig
}                                                                                      from '../../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import IField = Data.FieldManagement.IField;
import INdiStatistic = Data.NDI.INdiStatistic;
import IFieldCrop = Data.FieldManagement.IFieldCrop;
import ICropTypes = Data.BaseData.ICropTypes;
import ScanType = Data.NDI.Enums.ScanType;

@Component({
  selector: 'ndi-index',
  templateUrl: 'ndi.component.html',
  styleUrls: ['ndi.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NdiComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;

  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public pager$: Observable<ApDynGridPagerConfigBase>;
  public loading$ = of(true);
  public items$: Observable<INdiGridData[]>;
  public showDynComponent$ = new BehaviorSubject<boolean>(false);

  private _halfViewMode$ = new BehaviorSubject<NdiActiveView>(NdiActiveView.NUptake);
  private _halfViewModeChange = new EventEmitter<void>();
  private _statisticUpdateRequested = new EventEmitter<void>();
  private _applyClicked = new EventEmitter<any>();
  private _subscriptions: Array<Subscription> = [];

  constructor(private fieldStore: FieldStore,
              private loginStore: LoginStore,
              private ndiStore: NdiStore,
              private notifyStore: NotifyStore,
              private dateService: ApDateService,
              private mapViewStore: MapViewStore,
              private settingsStore: SettingsStore,
              private languageStore: LanguageStore,
              private statisticStore: StatisticStore,
              private campaignYearStore: CampaignYearStore,
              private nUptakeFactorsStore: NUptakeFactorsStore,
              private translationService: ApTranslationService,
              private cropService: ApGetCropService,
              private mapStore: MapStore,
              private ndiService: NdiService,
              private statisticService: StatisticService,
              private agriportConstantsService: AgriportConstantsService,
              private campaignYearService: CampaignYearService,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  public ngOnInit(): void {
    this.updateLayerVisibility();
    this.loading$ = combineLatest([
      this.ndiStore.Loading$,
      this.fieldStore.Loading$,
      this.settingsStore.Loading$,
      this.languageStore.Loading$,
      this.nUptakeFactorsStore.Loading$
    ]).pipe(
      map(loadingItems => loadingItems.some(x => x))
    );
    this._subscriptions.push(this._halfViewModeChange.subscribe(() => {
      const nextView = this._halfViewMode$.value === NdiActiveView.NIndex ?
        NdiActiveView.NUptake : NdiActiveView.NIndex;
      this._halfViewMode$.next(nextView);
      this.updateLayerVisibility();
    }));
    this._subscriptions.push(
      this.campaignYearStore.SelectedCampaignYear$.pipe(
        distinctUntilChanged((previous, current) => previous?.Year === current?.Year),
      ).subscribe(selectedCampaignYear => {
        const currentFarmDate = this.dateService.getFarmDate();
        const currentCampaignYear = this.campaignYearService.getCampaignYearByDate(currentFarmDate);
        const isNeedToShowComponent = currentCampaignYear.CampaignYear === selectedCampaignYear?.Year;
        this.mapStore.Legends.onNdiLegendShow.emit(isNeedToShowComponent);
        this.showDynComponent$.next(isNeedToShowComponent);
      })
    );
    this.items$ = combineLatest([
      this.fieldStore.Fields$,
      this.ndiStore.NdiStatistics$,
      this.nUptakeFactorsStore.nUptakeFactors$
    ]).pipe(
      filter(([fields, nIndexData, nUptakeFactors]) => !!fields && !!nIndexData && !!nUptakeFactors),
      map(([fields, nIndexData]) => this._getItems(fields, nIndexData)),
    );
    this._subscriptions.push(
      this._statisticUpdateRequested.pipe(debounceTime(100)).subscribe(_ => this._generateStats())
    );
    this._subscriptions.push(
      this.items$.subscribe(_ => this._statisticUpdateRequested.emit())
    );
    this._subscriptions.push(
      combineLatest([
        this.mapViewStore.Listen(s => s.mode),
        this.mapViewStore.Listen(s => s.currentMenu)
      ]).subscribe(([mapMode, mapMenu]) => {
        if (mapMode === MapViewMode.HIDE) {
          return;
        }
        this.statisticStore.removeStatisticData();
        switch (mapMenu) {
          case MapViewCurrentMenu.STATS:
            this._generateStats();
            break;
          case MapViewCurrentMenu.MAP:
            setTimeout(() => this.updateLayerVisibility(), 500);
            break;
        }
      })
    );
  }

  public ngAfterContentInit(): void {
    this._gridBuilder();
    this._subscriptions.push(
      this.dynComponent.SelectedItems$.subscribe(d => this._selectionChange(d))
    );
    this._subscriptions.push(
      this._applyClicked.subscribe((e) => this._onApplyClicked(e))
    );
    this._subscriptions.push(
      this.fieldStore.Listen(x => x.fieldCropsSaved).subscribe(x => this._invokeWhenFieldCropsUpdated(x))
    );
  }

  public ngOnDestroy(): void {
    this.statisticStore.removeStatisticData();
    this._subscriptions.forEach(d => d.unsubscribe());
  }

  private _getItems(fields: IField[], ndiStatistics: INdiStatistic[]): INdiGridData[] {
    return fields.filter(x => !!x).map((field: IField) => {
      if (!field) {
        return null;
      }
      let fieldCrop = this.cropService.getFieldCrop(field);
      const mainCrop = this.cropService.getCropType(fieldCrop, true);
      fieldCrop = mainCrop ? fieldCrop : null;
      const ndiSatScan = ndiStatistics.find(x => x.FieldGeomId === field.DefaultGeom?.Id);
      const createdDate = !!ndiSatScan?.Created ? new Date(ndiSatScan.Created) : undefined;
      const satelliteNValues = this.ndiService.getSatelliteNValues(ndiSatScan, fieldCrop);
      const isNdiScanValid = this.ndiService.isNdiScanValid(ndiSatScan);
      const gridStatus = this.getStatusForNdiGridItem(ndiSatScan);
      const nUptakeStatus = this.getNUptakeStatus(mainCrop, fieldCrop, satelliteNValues);
      const item: INdiGridData = {
        Id: field.Id,
        Status: gridStatus,
        Name: field.FieldName,
        Nr: field.FieldNumber,
        TNr: field.FieldSubnumber,
        NrSNr: this.fieldStore.getFieldNumberAndSubNumber(field),
        FieldCrop: mainCrop?.Description ? fieldCrop : null,
        CropType: mainCrop?.Description ?? '',
        EcValue: fieldCrop?.EcValue,
        Area: (field.DefaultGeom?.AdminArea ?? 0) / 10000,
        Date: isNdiScanValid ? this.dateService.getDateMidnight(createdDate) : undefined,
        NUptakeStatus: nUptakeStatus,
        SatelliteNValues: satelliteNValues
      };
      return item;
    });
  }

  private _gridBuilder(): void {
    this.columns$ = combineLatest([
      this.campaignYearStore.SelectedCampaignYear$,
      this.loginStore.User$,
      this.languageStore.SelectedLanguage$,
      this.settingsStore.FirstSetting$
    ]).pipe(
      map(([_, _1, language, settings]) => [
        new ApDynGridStatusColumnConfig({
          field: `${nameOf<INdiGridData>('Status')}.${nameOf<IGridStatus>('state')}`,
          class: `${nameOf<INdiGridData>('Status')}.${nameOf<IGridStatus>('class')}`,
          description: `${nameOf<INdiGridData>('Status')}.${nameOf<IGridStatus>('description')}`,
          showHeaderTitle: false,
          filterable: true,
          defaultFilter: [NdiGridItemState.GreenRegular, NdiGridItemState.GreenAutumn]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: nameOf<INdiGridData>('Nr'),
          hide: true,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true,
          width: 60
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldPartShort',
          field: nameOf<INdiGridData>('TNr'),
          hide: true,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true,
          width: 60
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: nameOf<INdiGridData>('NrSNr'),
          width: 75,
          filterable: true,
          headerFilterable: true,
          hide: new ApDynGridColumnHideConfig({
            mapHide: false,
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
          })
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldName',
          field: nameOf<INdiGridData>('Name'),
          filterable: true,
          headerFilterable: true,
          sortIndex: 0,
          sortDesc: false,
          width: 120,
          cssClass: 'left',
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Area',
          field: nameOf<INdiGridData>('Area'),
          hide: true,
          headerFilterable: true,
          tooltip: (dataItem: INdiGridData) => dataItem.Area ? dataItem.Area.toString(10) : '-',
          filterType: FilterType.NUMBER,
          width: 40,
          cssClass: 'right',
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [settings.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Crop',
          field: nameOf<INdiGridData>('CropType'),
          filterable: true,
          headerFilterable: true,
          width: 100
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'ECStageShort',
          field: nameOf<INdiGridData>('EcValue'),
          filterable: true,
          headerFilterable: true,
          width: 40,
          cssClass: 'right',
          filterType: FilterType.NUMBER
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Planning_Date',
          field: nameOf<INdiGridData>('Date'),
          hide: true,
          filterable: true,
          headerFilterable: true,
          format: language.DateFormat,
          width: 80
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__NDI_Name',
          hide: true,
          width: 215,
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Min',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NIndexMin')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Avg_Symbol',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NIndexAvg')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Max',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NIndexMax')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            })
          ]
        }),
        new ApDynGridGroupColumnConfig({
          title: 'N__UptakeUnit',
          hide: true,
          width: 215,
          groupColumns: [
            new ApDynGridStatusColumnConfig({
              title: 'NUptakeStatus',
              groupTitle: 'NUptakeStatus',
              field: `${nameOf<INdiGridData>('NUptakeStatus')}.${nameOf<IGridStatus>('state')}`,
              class: `${nameOf<INdiGridData>('NUptakeStatus')}.${nameOf<IGridStatus>('class')}`,
              description: `${nameOf<INdiGridData>('NUptakeStatus')}.${nameOf<IGridStatus>('description')}`,
              showHeaderTitle: false,
              filterable: true,
              groupIndex: 0,
              groupDesc: false
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Min',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NUptakeMin')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Avg_Symbol',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NUptakeAvg')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Max',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NUptakeMax')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            })
          ]
        }),
        new ApDynGridGroupColumnConfig({
          title: this._halfViewMode$.pipe(map((m) => m === 0 ? 'Global__NDI_Name' : 'N__UptakeUnit')),
          hide: new ApDynGridColumnHideConfig({
            mapHide: false,
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
          }),
          headerButtons: {
            nextClicked: this._halfViewModeChange,
            previousClicked: this._halfViewModeChange,
            nextDisabled: of(false),
            previousDisabled: of(false)
          },
          xlsExport: false,
          width: 215,
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Min',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NIndexMin')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this._halfViewMode$.pipe(map((m) => m === NdiActiveView.NUptake))
              }),
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Avg_Symbol',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NIndexAvg')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this._halfViewMode$.pipe(map((m) => m === NdiActiveView.NUptake))
              }),
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Max',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NIndexMax')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this._halfViewMode$.pipe(map((m) => m === NdiActiveView.NUptake))
              }),
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridStatusColumnConfig({
              title: 'NUptakeStatus',
              field: `${nameOf<INdiGridData>('NUptakeStatus')}.${nameOf<IGridStatus>('state')}`,
              class: `${nameOf<INdiGridData>('NUptakeStatus')}.${nameOf<IGridStatus>('class')}`,
              description: `${nameOf<INdiGridData>('NUptakeStatus')}.${nameOf<IGridStatus>('description')}`,
              groupTitle: 'NUptakeStatus',
              showHeaderTitle: false,
              filterable: true,
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this._halfViewMode$.pipe(map((m) => m === NdiActiveView.NIndex))
              }),
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Min',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NUptakeMin')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this._halfViewMode$.pipe(map((m) => m === NdiActiveView.NIndex))
              }),
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Avg_Symbol',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NUptakeAvg')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this._halfViewMode$.pipe(map((m) => m === NdiActiveView.NIndex))
              }),
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Max',
              field: `${nameOf<INdiGridData>('SatelliteNValues')}.${nameOf<SatelliteNValues>('NUptakeMax')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 65,
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this._halfViewMode$.pipe(map((m) => m === NdiActiveView.NIndex))
              }),
              pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
            })
          ]
        })
      ])
    );

    this.pager$ = new BehaviorSubject(new ApDynGridPagerConfig({
      listMassEditing: [
        {
          id: FieldMassEditAction.EditMainCrop,
          type: ApGridPagerType.None,
          name: this.translationService.translate('Global__Edit'),
          onSubmit: this._applyClicked,
          formConfig: [
            new ApDynformsConfigFieldset({
              key: 'SatelliteDetailsFieldSet',
              config: [
                new ApDynformsConfigNumerictextbox({
                  key: 'EcValueToUpdate',
                  label: 'ECStageShort',
                  min: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MIN'),
                  max: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MAX'),
                  decimals: 0,
                  format: 'n0',
                  validators: [
                    new ApDynformsValidator({validator: Validators.required, errorKey: ''})
                  ]
                }),
                new ApDynformsConfigPlaceholder()
              ]
            })
          ]
        } as IDynGridWizardChoiceData
      ],
      apply: this._applyClicked,
      hasPermission: true
    }));
  }

  /**
   * Determines the grid status for an NDI record based on statistics.
   * @param ndiStatistic - NDI statistic object.
   * @returns Grid status object with state, class and description.
   * @remarks Status rules:
   * - Green status with regular scan class if statistics is regular
   * - Green status with autumn scan class if statistics is autumn
   * - Grey status if no statistics present
   * @public
   */
  private getStatusForNdiGridItem(ndiStatistic: INdiStatistic | undefined): IGridStatus {
    switch (ndiStatistic?.ScanType) {
      case ScanType.Regular:
        return {
          state: NdiGridItemState.GreenRegular,
          class: 'ap-status-green-regular-scan',
          description: 'Global__NDI_Status_Desc_green'
        };
      case ScanType.Autumn:
        return {
          state: NdiGridItemState.GreenAutumn,
          class: 'ap-status-green-autumn-scan',
          description: 'Global__NDI_Status_Desc_autumn'
        };
      default:
        return {
          state: NdiGridItemState.Yellow,
          class: 'ap-status-grey',
          description: 'Global__NDI_Status_Desc_grey'
        };
    }
  }

  private getNUptakeStatus(mainCrop: ICropTypes | undefined, fieldCrop: IFieldCrop | undefined,
                           satelliteValues: SatelliteNValues | undefined): IGridStatus {
    const nUptakeFactor = this.ndiService.getNUptakeFactor(fieldCrop);
    if (!!mainCrop && !!fieldCrop?.EcValue && !!nUptakeFactor) {
      if (!!satelliteValues && Number.isFinite(satelliteValues.NUptakeAvg)) {
        return {
          state: NdiNUptakeState.Green,
          class: 'ap-status-green',
          description: ''
        };
      }
      return {
        state: NdiNUptakeState.Yellow,
        class: 'ap-status-yellow',
        description: ''
      };
    }
    return {
      state: NdiNUptakeState.Grey,
      class: 'ap-status-grey',
      description: ''
    };
  }

  private _onApplyClicked(event: IGridPagerData): void {
    if (!event) {
      return;
    }
    if (event.object.id === SatelliteMassEditAction.Edit) {
      const selectedFieldCrops = (this.dynComponent.getSelectedItems() as INdiGridData[])
        .filter(x => x.FieldCrop)
        .map(x => x.FieldCrop);
      if (!selectedFieldCrops || selectedFieldCrops.length <= 0) {
        return;
      }
      const copiedFieldCrops = ObjectFactory.Copy(selectedFieldCrops);
      copiedFieldCrops.forEach(fieldCrop => {
        fieldCrop.EcValue = event.value ?? event.form['EcValueToUpdate'];
      });
      this.fieldStore.saveFieldCrops(copiedFieldCrops);
    }
  }

  private _invokeWhenFieldCropsUpdated(isUpdated: boolean | undefined): void {
    if (isUpdated === undefined) {
      return;
    }
    if (isUpdated) {
      this.notifyStore.showSaveSuccessMessage();
    } else {
      this.notifyStore.showSaveFailMessage();
    }
    MapFactoryStyler.Instance?.clearStyleCache();
    this.mapStore.Layers?.NUptakeLayer?.reload();
  }

  private _selectionChange(currentSelected: INdiGridData[]): void {
    this.fieldStore.changeSelectedField(currentSelected.Convert((gridRow: INdiGridData) => gridRow.Id.toString()));
    this._statisticUpdateRequested.emit();
  }

  /**
   * Generates the statistic diagrams for last sampling-dates and planned sampling dates
   * @private
   */
  private _generateStats(): void {
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.STATS
      || this.mapViewStore.getMapViewMode() === MapViewMode.HIDE
      || !this.showDynComponent$.getValue()) {
      return;
    }
    let items = this.dynComponent.getSelectedItems() as INdiGridData[];
    if (!items || items?.length === 0) {
      items = this.dynComponent.items as INdiGridData[];
    }
    if (items?.length === 0) {
      this.statisticStore.setStatisticData([], ApStatsType.FieldsNdiStats, '', '');
      return;
    }
    // apply grid's current sort descriptor on our statistic items to have the same sort as user
    items = orderBy(items, this.dynComponent.dynGrid.gridPaging.getDescriptors().sort);
    const statisticData: IFieldsNdiStatsData[] = items.map(item => {
      return {
        FieldId: item.Id,
        FieldName: item.Name,
        AreaHa: item.Area,
        Cells: item.SatelliteNValues?.Cells,
        NIndexMin: item.SatelliteNValues?.NIndexMin,
        NIndexMax: item.SatelliteNValues?.NIndexMax,
        NIndexAvg: item.SatelliteNValues?.NIndexAvg,
        NIndexHistogram: item.SatelliteNValues?.NIndexHistogram,
        NUptakeMin: item.SatelliteNValues?.NUptakeMin,
        NUptakeMax: item.SatelliteNValues?.NUptakeMax,
        NUptakeAvg: item.SatelliteNValues?.NUptakeAvg,
        NUptakeHistogram: item.SatelliteNValues?.NUptakeHistogram,
      } as IFieldsNdiStatsData;
    });
    // generate each diagram/chart and add to statistics
    const title = this._getTitleForStatistic(items);
    this.statisticStore.setStatisticData(statisticData, ApStatsType.FieldsNdiStats, title, '');
  }

  private _getTitleForStatistic(selectedItems: INdiGridData[]): string {
    const totalItems = this.dynComponent.items as INdiGridData[];
    const dataForTitles = totalItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    return this.statisticService.generateFieldsAreaTitle(dataForTitles);
  }

  /**
   * Updates layer visibility depending on the current state of the component
   * @private
   */
  private updateLayerVisibility(): void {
    this.mapStore.Layers.NUptakeLayer.Visibility = (this._halfViewMode$.getValue() === NdiActiveView.NUptake);
    this.mapStore.Layers.NdiLayer.Visibility = (this._halfViewMode$.getValue() === NdiActiveView.NIndex);
  }
}
